import gql from "graphql-tag";

// fragment
export const PRODUCT_FRAGMENT = gql`
    fragment product on ProductNode {
        id
        name
        externalId
        externalCode
        printPriority
        unitCorrection
        isDynamic
        productCategory {
            id
            name
        }
        updatedAt
        updatedBy
    }
`;

export const PRODUCT_WITH_PLANTS_FRAGMENT = gql`
    fragment productWithPlants on ProductNode {
        id
        name
        externalId
        externalCode
        externalPotsize
        externalHeight
        externalCover
        externalLabel
        externalSticker
        isPlantsConfigured
        isDynamic
        isPlantsConfigured
        numMixPlantsPerUnitMin
        numMixPlantsPerUnitMax
        numColorsPerUnitMin
        numColorsPerUnitMax
        printPriority
        unitCorrection
        productCategory {
            id
            name
            printPriority
        }
        productItemSet(orderBy: "priority") {
            edges {
                node {
                    id
                    numPlants
                    priority
                    availableSalesInventory
                    plant {
                        id
                        name
                        plantSpecies {
                            id
                            name
                        }
                        defaultSupplier {
                            id
                            name
                        }
                        plantColorSet {
                            edges {
                                node {
                                    id
                                    color {
                                        id
                                        color
                                    }
                                }
                            }
                        }
                        plantPotSizeSet {
                            edges {
                                node {
                                    id
                                    potSize {
                                        id
                                        potSizeCm
                                    }
                                }
                            }
                        }
                        plantEnvironmentSet {
                            edges {
                                node {
                                    id
                                    environment {
                                        id
                                        environment
                                    }
                                }
                            }
                        }
                        plantTagSet {
                            edges {
                                node {
                                    id
                                    tag {
                                        id
                                        tag
                                    }
                                }
                            }
                        }
                    }
                    color {
                        id
                        color
                    }
                    potSize {
                        id
                        potSizeCm
                    }
                    environment {
                        id
                        environment
                    }
                    tag {
                        id
                        tag
                    }
                }
            }
        }
        productFixedCostTemplate {
            id
            templateName
            totalCost
            productFixedCostTemplateItemSet {
                edges {
                    node {
                        id
                        itemName
                        costValue
                    }
                }
            }
        }
    }
`;

// all query
export const PRODUCTS_QUERY = gql`
    query {
        tenantProducts(first: 100, orderBy: "name") {
            edges {
                node {
                    ...product
                }
            }
        }
    }
    ${PRODUCT_FRAGMENT}
`;

// single query
export const SINGLE_PRODUCT_QUERY = gql`
    query product($id: ID!) {
        product(id: $id) {
            ...productWithPlants
        }
    }
    ${PRODUCT_WITH_PLANTS_FRAGMENT}
`;

// create
export const CREAT_PRODUCT_MUTATION = gql`
    mutation createProduct($input: CreateProductInput!) {
        createProduct(input: $input) {
            product {
                ...productWithPlants
            }
        }
    }
    ${PRODUCT_WITH_PLANTS_FRAGMENT}
`;

// update
export const UPDATE_PRODUCT_MUTATION = gql`
    mutation updateProduct($input: UpdateProductInput!) {
        updateProduct(input: $input) {
            product {
                ...productWithPlants
            }
        }
    }
    ${PRODUCT_WITH_PLANTS_FRAGMENT}
`;

// update product items
export const UPDATE_PRODUCT_ITEMS_MUTATION = gql`
    mutation updateProductItems($input: UpdateProductItemsInput!) {
        updateProductItems(input: $input) {
            product {
                ...productWithPlants
            }
        }
    }
    ${PRODUCT_WITH_PLANTS_FRAGMENT}
`;

// delete
export const DELETE_PRODUCT_MUTATION = gql`
    mutation deleteProduct($input: DeleteProductInput!) {
        deleteProduct(input: $input) {
            product {
                ...productWithPlants
            }
        }
    }
    ${PRODUCT_WITH_PLANTS_FRAGMENT}
`;
